/* eslint-disable react/no-danger */
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { IconAngleRight } from '@/Module/Icon';
import { Lesson } from '@/Module/Lesson/Component';
import type { ICourse } from '@/Module/Lesson/Model/DataModel';
interface ILessonListHeaderProps {
  title: string;
  description?: string;
  badgeTitle?: string;
  courseId: ICourse['id'];
}
const LessonListHeader: FC<ILessonListHeaderProps> = ({
  title,
  description,
  courseId,
  badgeTitle
}) => {
  const router = useRouter();
  const onBackClick = () => {
    /*    router.push(
      prepareGradeUrl({
        id: gradeId,
        seoUrlSlug: gradeSeoUrlSlug,
      }),
    ); */
    router.back();
  };
  return <div className="mb-9 flex flex-col items-center gap-12 lg:mb-12 lg:flex-row lg:gap-4" data-sentry-component="LessonListHeader" data-sentry-source-file="LessonSectionListHeader.tsx">
      <div className="flex  items-center   gap-2 lg:gap-4">
        <Button variant="text" color="orangeDark" onClick={onBackClick} iconButton data-sentry-element="Button" data-sentry-source-file="LessonSectionListHeader.tsx">
          <IconAngleRight data-sentry-element="IconAngleRight" data-sentry-source-file="LessonSectionListHeader.tsx" />
        </Button>
        <Lesson id={courseId} className="w-[140px] lg:w-[150px]" imgWidth={132} hideTitle data-sentry-element="Lesson" data-sentry-source-file="LessonSectionListHeader.tsx" />
      </div>
      <div className="flex w-full flex-col items-start gap-2 pr-4 text-right lg:gap-2">
        <h1 className="text-2xl font-bold text-orangeSix lg:text-3xl ">{title}</h1>
        {badgeTitle && <div className="mb-2 text-lg font-semibold text-orangeFive lg:mb-2 ">{badgeTitle}</div>}
        {description && <div className="leading-8 text-blackfive prose-2xl text-justify text-base lg:text-lg" style={{
        whiteSpace: 'break-spaces'
      }} dangerouslySetInnerHTML={{
        __html: description
      }} />}
      </div>
    </div>;
};
export default LessonListHeader;